import React, { useState, useCallback, useEffect } from 'react';
import TemplateList from './AmendContract/TemplateList/TemplateList.container';
import TemplateDetail from './AmendContract/TemplateDetail/TemplateDetail.container';
import EditAmendment from './AmendContract/EditAmendment/EditAmendment.container';
import ReadyToCheck from './ValidateContract/ReadyToCheck/ReadyToCheck.container';
import Menu from './Menu/Menu';
import useGrouping from 'Common/Utils/Hooks/useGrouping';

const initialState = { activeMenu: '', activeMenuProps: null };

const GenericContractReleaseContainer = () => {
	const [{ activeMenu, activeMenuProps }, setActive] = useState(initialState);
    const grouping = useGrouping();

    useEffect(() => {
        setActive(initialState);
    }, [grouping]);

	const handleMenuChange = useCallback((menuToOpen, menuProps) => {
        setActive({ activeMenu: menuToOpen, activeMenuProps: menuProps });
	}, []);

	switch (activeMenu) {
		case 'check_contract':
			return (
				<ReadyToCheck />
			);
		case 'amend_contract':
			return (
				<TemplateList onClose={handleMenuChange} {...activeMenuProps} />
			);
		case 'amend_contract_detail':
			return (
				<TemplateDetail onClose={handleMenuChange} {...activeMenuProps} />
			);
        case 'edit_amendment':
            return (
                <EditAmendment onClose={handleMenuChange} {...activeMenuProps} />
            );
		default:
			return (
				<Menu onChange={handleMenuChange} />
			);
	}
};

export default GenericContractReleaseContainer;
